import React, { useEffect, useState } from "react";
import Footer from "../../../Components/Footer/footer";
import SimpleButton from "../../../Components/layouts/simple_button";
import StepRoutes from "../../../Routes/steps_routes";
import { useNavigate, useParams } from "react-router-dom";
import LoadingPage from "../../../Components/layouts/loading";
import { Toast } from "../../../CustomComponent/toast";
import performRequest from "../../../api/request";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";

const ViewRFQ = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  let { id } = useParams();
  const navigate = useNavigate();

  const duplicateRFQ = () => {
    navigate(`/rfq/new?duplicate=${id}`);
  };
  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/rfq/getRFQById/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
        } else {
          Toast("error", "Error while getting PO!");
        }
        setLoading(false);
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id]);
  if (loading) {
    return <LoadingPage />;
  }
  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">Purchase Management</h2>
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="card my-4">
            <div className="card-header">
              <h2 className="page-title">View RFQ</h2>
            </div>

            <div className="card-body">
              {data?.vendor && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Vendor</label>
                  <div className="w-100 col">
                    <a
                      href={`/purchase-vendor-management/view-vendor/${data?.vendor}`}
                    >
                      View
                    </a>
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Vendor quotation for
                  </label>
                  <div className="w-100 col">
                    {(data?.vendorQuotationOrderFor || "N/A").toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Vendor quotation order date
                  </label>
                  <div className="w-100 col">
                    {(data?.vendorQuotationOrderDate || "N/A").toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">Project</label>
                  <div className="w-100 col">
                    {(data.project || "N/A").toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Country of supply
                  </label>
                  <div className="w-100 col">
                    {(data?.countryOfSupply || "N/A").toUpperCase()}
                  </div>
                </div>
              )}
              {data && (
                <div className="mb-3 row">
                  <label className="w-25 form-label col-3">
                    Place of supply
                  </label>
                  <div className="w-100 col">
                    {(data?.placeOfSupply || "N/A").toUpperCase()}
                  </div>
                </div>
              )}
              <hr />
              <h2>Line Items</h2>
              <hr />
              {data &&
                data.lineItems?.map((lineItem, index) => {
                  return (
                    <div>
                      <h2>{++index}.</h2>
                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3">
                          Particulars
                        </label>
                        <div className="w-100 col">
                          {(lineItem?.particulars || "N/A").toUpperCase()}
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3">
                          Item unit
                        </label>
                        <div className="w-100 col">
                          {(lineItem?.itemUnit || "N/A").toUpperCase()}
                        </div>
                      </div>
                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3">
                          Item quantity
                        </label>
                        <div className="w-100 col">
                          {(lineItem?.itemQuantity || "N/A").toUpperCase()}
                        </div>
                      </div>

                      <div className="mb-3 row">
                        <label className="w-25 form-label col-3">
                          Delivery date
                        </label>
                        <div className="w-100 col">
                          {(lineItem?.deliveryDate || "N/A").toUpperCase()}
                        </div>
                      </div>
                      <hr />
                    </div>
                  );
                })}
            </div>
            <div className="card-footer">
              <div className="btn-list justify-content-end">
                <SimpleButton
                  buttonText={"generate pdf"}
                  href={`/rfq/preview/${id}`}
                />
                <SimpleButton buttonText="Edit RFQ" href={`/rfq/edit/${id}`} />

                <SimpleButton buttonText="Duplicate" onClick={duplicateRFQ} />

                <SimpleButton buttonText="Cancel" type="secondary" />
              </div>
            </div>
          </div>
        </div>

        <Footer />
      </div>
    </div>
  );
};

export default ViewRFQ;
